import $ from 'jquery';

function updateModalGallery(modalEl, thumbButton) {
	if (!modalEl || !thumbButton) return;

	const mainImage = modalEl.querySelector('.js-bukken-detail-modal-main');
	const caption = modalEl.querySelector('.js-bukken-detail-modal-caption');

	const nextMainSrc = thumbButton.dataset.image || '';
	const nextCaption = thumbButton.dataset.caption || '';

	if (mainImage && nextMainSrc) {
		mainImage.setAttribute('src', nextMainSrc);
	}

	if (caption) {
		caption.textContent = nextCaption;
	}

	modalEl.querySelectorAll('.bukkenDetailModal__thumb').forEach((button) => {
		button.classList.toggle('is-active', button === thumbButton);
	});
}

function bindModalGallery(modalEl) {
	if (!modalEl || modalEl.dataset.galleryBound === 'true') return;

	const thumbsRoot = modalEl.querySelector('[data-gallery-thumbs]');
	const closeButton = modalEl.querySelector('.js-bukken-detail-modal-close');
	if (!thumbsRoot) return;

	thumbsRoot.addEventListener('click', (event) => {
		const thumbButton = event.target.closest('.bukkenDetailModal__thumb');
		if (!(thumbButton instanceof HTMLButtonElement)) return;
		updateModalGallery(modalEl, thumbButton);
	});

	thumbsRoot.addEventListener('mouseenter', (event) => {
		if (!window.matchMedia('(min-width: 769px)').matches) return;
		const thumbButton = event.target.closest('.bukkenDetailModal__thumb');
		if (!(thumbButton instanceof HTMLButtonElement)) return;
		updateModalGallery(modalEl, thumbButton);
	}, true);

	if (closeButton instanceof HTMLButtonElement) {
		closeButton.addEventListener('click', () => {
			$.magnificPopup.close();
		});
	}

	modalEl.dataset.galleryBound = 'true';
}

function bindFloorModal(modalEl) {
	if (!modalEl || modalEl.dataset.floorBound === 'true') return;

	const closeButton = modalEl.querySelector('.js-bukken-detail-floor-close');

	if (closeButton instanceof HTMLButtonElement) {
		closeButton.addEventListener('click', () => {
			$.magnificPopup.close();
		});
	}

	modalEl.dataset.floorBound = 'true';
}

export function init() {
	const trigger = document.querySelector('.js-bukken-detail-gallery-trigger');
	const modalEl = document.getElementById('bukken-detail-gallery-modal');
	const floorTrigger = document.querySelector('.js-bukken-detail-floor-trigger');
	const floorModalEl = document.getElementById('bukken-detail-floor-modal');

	if (!trigger && !floorTrigger) return;

	const setupPopup = () => {
		if (trigger && modalEl) {
			bindModalGallery(modalEl);

			$(trigger).magnificPopup({
				type: 'inline',
				items: {
					src: '#bukken-detail-gallery-modal',
				},
				closeBtnInside: true,
				mainClass: 'bukken-detail-gallery-popup',
				callbacks: {
					open() {
						const activeThumb = modalEl.querySelector('.bukkenDetailModal__thumb.is-active') || modalEl.querySelector('.bukkenDetailModal__thumb');
						if (activeThumb instanceof HTMLButtonElement) {
							updateModalGallery(modalEl, activeThumb);
						}
					},
				},
			});
		}

		if (floorTrigger && floorModalEl) {
			bindFloorModal(floorModalEl);

			$(floorTrigger).magnificPopup({
				type: 'inline',
				items: {
					src: '#bukken-detail-floor-modal',
				},
				closeBtnInside: true,
				mainClass: 'bukken-detail-floor-popup',
			});
		}
	};

	if ($.fn.magnificPopup) {
		setupPopup();
		return;
	}

	import('magnific-popup/dist/jquery.magnific-popup.js').then(setupPopup);
}
